import store from "../../../redux/store";
import { updateUserNotificationToken } from "./notificationApis";
import * as auth from "../../../app/modules/Auth/_redux/authRedux";
import { backend_url, uninterceptedAxiosInstance,qs } from "../common/commonVariables";
import { throwError } from "../common/commonFunctions";

export const handleLogout = async () => {
    const {
      auth: { user },
    } = store.getState();
  
    if (user?.id) {
      await updateUserNotificationToken(user.id, "", "", true);
    }
  
    store.dispatch(auth.actions.logout());

  };

  export const changePassword = async (password, id, organisation) => {
    try {
      let params = {
        password,
        organisation,
      };
     
      const response = await uninterceptedAxiosInstance.put(
        backend_url + "users/" + id,
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
      
      return the_response;
    } catch (err) {
      
      if (err.response) {
        
      } else if (err.request) {
        
      } else {
        
      }
     
    }
  };

  export const updateUserStatusToActive = async (id) => {
    try {
      let params = {
        confirmed: true,
      };
     
      const response = await uninterceptedAxiosInstance.put(
        backend_url + "users/" + id,
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response;
      
      return the_response;
    } catch (err) {
      
      if (err.response) {
        
      } else if (err.request) {
        
      } else {
        
      }
     
    }
  };

  export const resetPassword = async (code, password, passwordConfirmation) => {
    try {
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "auth/reset-password",
        {
          code,
          password,
          passwordConfirmation,
        }
      );
  
      let the_response = response;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      throw new Error(err);
    }
  };

  export const changeLoggedInUserPassword = async (
    oldPassword,
    newPassword,
    confirmPassword
  ) => {
    try {
      let params = {
        oldPassword,
        newPassword,
        confirmPassword,
      };
  
     
  
      const response = await uninterceptedAxiosInstance.post(
        backend_url + `users/changePassword`,
        params,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      let the_response = response;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      return {
        status: err?.response?.status,
        error: err?.response?.data?.error,
      };
    }
  };

  export const login = async (email, password) => {
    try {
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "auth/local/",
        {
          password: password,
          identifier: email,
        }
      );
  
      let the_response = response;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      throw throwError({
        message: err.message,
        status: err.response?.status,
      });
    }
  };
  export const requestPassword = async (email) => {
    try {
      const response = await uninterceptedAxiosInstance.post(
        backend_url + "auth/forgot-password",
        {
          email,
        }
      );
  
      let the_response = response;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      throw new Error(err);
    }
  };
  